import { motion } from "framer-motion";
import { Phone, Mail, Globe, UserRound, ArrowRight } from "lucide-react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import ParticleBackground from "../components/ParticleBackground";

const team = [
  {
    name: "Eiffeltech Team",
    role: "Chief Executive Officer",
    image: "/projects/1.jpeg",
    phone: "+263716292923",
    email: "info@eiffeltech.co.zw",
    website: "https://eiffeltech.co.zw",
    linkedin: "https://linkedin.com/in/eiffeltech",
    github: "https://github.com/eiffeltech",
    bio: "Leading Eiffeltech with a vision to build modern digital solutions for businesses and institutions",
  },
  {
    name: "Tinotenda T. Chigumira",
    role: "Software Developer",
    image: "/projects/dev1.jpeg",
    phone: "+263716292923",
    email: "chigumira21@gmail.com",
    website: "https://tinotendachigumira.eiffeltech.co.zw/",
    linkedin: "https://linkedin.com/in/tinotenda-chigumira",
    github: "https://github.com/TynoeChigz",
    bio: "Full-stack developer focused on React, Node.js, databases, dashboards and secure digital systems.",
  },
  {
    name: "Tendai Chigumira",
    role: "Team Member",
    image: "/projects/tendai.jpeg",
    phone: "263775805610",
    email: "tendaichigumira15@gmail.com",
    website: "https://tendaichigumira.eiffeltech.co.zw",
    linkedin: "https://www.linkedin.com/in/tendai-chigumira-002b73294/",
    github: "https://github.com/tendai-chigumira-002b73294",
    bio: "Supporting Eiffeltech operations, digital services and client-focused technology delivery.",
  },
   {
    name: "Leo Shamu",
    role: "Software Developer",
    image: "/projects/leo.jpeg",
    phone: "+263 71 375 9858",
    email: "leoshamu12@gmail.com",
    website: "https://leoshamu.github.io/Portfolio/",
    linkedin: "https://linkedin.com/in/leo-shamu-6957182a6/",
    github: "https://github.com/leoshamu",
    bio: "Developer specializing in React, Node.js, database systems, and secure, scalable digital solutions.",
  },
   {
    name: "Eldrin Zarima",
    role: "Software Developer",
    image: "/projects/eldrin.jpeg",
    phone: "+263 71 237 3162",
    email: "zarimaeldrin@gmail.com",
    website: "https://zarimaeldrin.eiffeltech.co.zw",
    linkedin: "https://www.linkedin.com/in/eldrin-zarima-770462362?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
    github: "https://github.com/zarimaeldrin-ops",
    bio: "Delivering secure, data-driven applications using React, Node.js, and advanced database systems.",
  },
];

function Team() {
  return (
<section className="relative flex min-h-[88vh] items-center justify-center overflow-hidden px-4 pb-10 pt-24 sm:min-h-screen sm:px-6 sm:pt-28">

  {/* BACKGROUND */}
  <div className="absolute inset-0 z-0">
    <ParticleBackground />
  </div>

 

 
 
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="mx-auto max-w-4xl text-center"
        >
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-cyan-400 sm:text-sm sm:tracking-[0.3em]">
            Our Team
          </p>

          <h1 className="mt-4 text-3xl font-black leading-tight tracking-tight sm:text-5xl md:text-7xl">
            Meet the people behind Eiffeltech
          </h1>

          <p className="mx-auto mt-5 max-w-3xl text-sm leading-7 text-slate-300 sm:mt-6 sm:text-lg sm:leading-8">
            Our team brings together leadership, software development and
            practical digital problem-solving to deliver reliable technology
            solutions.
          </p>
        </motion.div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:mt-16 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3 lg:gap-8">
          {team.map((member, index) => (
            <TeamCard key={member.name} member={member} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TeamCard({ member, index }) {
  const cleanPhone = member.phone?.replace(/\s/g, "");

  return (
    <motion.div
      initial={{ opacity: 0, y: 35 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.12 }}
      whileHover={{ y: -6 }}
      className="group overflow-hidden rounded-[1.5rem] border border-cyan-400/20 bg-slate-900/80 shadow-2xl backdrop-blur-xl sm:rounded-[2rem]"
    >
      <div className="relative h-60 overflow-hidden bg-slate-900 sm:h-72">
        <img
          src={member.image}
          alt={member.name}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent" />

        <div className="absolute right-4 top-4 flex gap-2 opacity-100 transition-all duration-300 sm:right-5 sm:top-5 sm:gap-3 lg:opacity-0 lg:group-hover:opacity-100">
          <a
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${member.name} LinkedIn`}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-black text-slate-950 hover:bg-cyan-400 sm:h-10 sm:w-10"
          >
            <FaLinkedin size={17} />
          </a>

          <a
            href={member.github}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${member.name} GitHub`}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-black text-slate-950 hover:bg-cyan-400 sm:h-10 sm:w-10"
          >
            <FaGithub size={17} />
          </a>
        </div>

        <div className="absolute bottom-4 left-4 right-4 sm:bottom-5 sm:left-5 sm:right-5">
          <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-cyan-400 text-slate-950 shadow-lg sm:mb-4 sm:h-14 sm:w-14">
            <UserRound size={24} />
          </div>

          <h2 className="text-xl font-black leading-tight text-white sm:text-2xl">
            {member.name}
          </h2>
          <p className="mt-1 text-sm font-semibold text-cyan-300 sm:text-base">
            {member.role}
          </p>
        </div>
      </div>

      <div className="p-5 sm:p-7">
        <p className="text-sm leading-7 text-slate-300 sm:text-base">
          {member.bio}
        </p>

        <div className="mt-5 space-y-3 sm:mt-6">
          {member.phone && (
            <a
              href={`tel:${cleanPhone}`}
              className="flex items-center gap-3 text-sm text-white hover:text-cyan-400"
            >
              <Phone size={16} className="shrink-0" />
              <span>{member.phone}</span>
            </a>
          )}

          {member.email && (
            <a
              href={`mailto:${member.email}`}
              className="flex items-center gap-3 text-sm text-white hover:text-cyan-400"
            >
              <Mail size={16} className="shrink-0" />
              <span className="break-all">{member.email}</span>
            </a>
          )}
        </div>

        <div className="mt-5 flex flex-col gap-2 sm:mt-6 sm:flex-row sm:flex-wrap sm:gap-3">
          <a
            href={member.website}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-cyan-400 px-4 py-2.5 text-sm font-bold text-slate-950 hover:bg-cyan-300"
          >
            <Globe size={16} />
            Website
          </a>

          <a
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-cyan-400 px-4 py-2.5 text-sm font-bold text-cyan-400 hover:bg-cyan-400 hover:text-slate-950"
          >
            <FaLinkedin size={16} />
            LinkedIn
          </a>

          <a
            href={member.github}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-cyan-400 px-4 py-2.5 text-sm font-bold text-cyan-400 hover:bg-cyan-400 hover:text-slate-950"
          >
            <FaGithub size={16} />
            GitHub
          </a>
        </div>

        <a
          href={member.website}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-cyan-400 hover:underline sm:mt-7 sm:text-base"
        >
          View Personal Website <ArrowRight size={17} />
        </a>
      </div>
    </motion.div>
  );
}

export default Team;
